import { gql } from "@apollo/client";

export const CHANGE_PHONE = gql`
  mutation changePhone($newNumber: String!) {
    changePhone(input: { newNumber: $newNumber })
  }
`;
